(() => {
  const config = window.PolygonsNativeCommerceConfig, context = window.PolygonsNativeContext;
  const marketEligible = config?.policy?.schema === 2 && config.policy.pricingMode === 'percent-after-bundle-v1' || context?.countryCode === 'US' && context.currencyCode === 'USD';
  const approved = Boolean(window.PolygonsNativeCommerce && context?.hostname === 'polygons-1.myshopify.com' && marketEligible
    && config?.offer?.schema === 1 && config.offer.enabled === true && config.offer.code === 'SHARKTANK5' && config.offer.percentage === 5);
  const button = document.querySelector('[data-native-offer]'), dialog = document.querySelector('[data-native-offer-dialog]');
  if (!button || !dialog || !approved) return;
  button.hidden = false;
  const submit = dialog.querySelector('[data-native-offer-submit]');
  if (submit) submit.disabled = false;
  const markSeen = () => { try { sessionStorage.setItem('polygons.offer5.native.seen', '1'); } catch {} };
  button.addEventListener('click', markSeen);
  const open = () => { if (window.PolygonsUI?.open('native-offer')) markSeen(); };
  const success = dialog.querySelector('[data-native-offer-success]');
  if (success) {
    const copy = dialog.querySelector('[data-native-offer-copy]');
    const code = dialog.querySelector('[data-native-offer-code]');
    const status = dialog.querySelector('[data-native-offer-copy-status]');
    copy?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code.value);
        copy.textContent = copy.dataset.copiedLabel;
        status.textContent = '';
      } catch {
        code.focus(); code.select();
        status.textContent = status.dataset.fallback;
      }
    });
    open();
    return;
  }
  if (dialog.querySelector('[data-native-offer-error]')) { open(); return; }
  let seen = false;
  try { seen = sessionStorage.getItem('polygons.offer5.native.seen') === '1'; } catch {}
  const canAutoOpen = () => {
    if (document.hidden) return false;
    const focused = document.activeElement;
    if (focused?.matches('input:not([type="hidden"]), select, textarea')
      || focused?.closest('[contenteditable]:not([contenteditable="false"])')) return false;
    const dialogs = document.querySelectorAll('dialog[open], [role="dialog"], [role="alertdialog"], [aria-modal="true"], [data-sheet].is-open');
    return ![...dialogs].some(element => !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length > 0);
  };
  if (!seen && !window.Shopify?.designMode) setTimeout(() => {
    if (canAutoOpen()) open();
  }, 4000);
})();
